export enum EFilterKpiViewTypes {
  RADIO_GROUP_TEMPLATE = 'RADIO_GROUP_TEMPLATE',
  CHECK_BOXES_WITH_SEARCH = 'CHECK_BOXES_WITH_SEARCH',
  CHECK_BOXES = 'CHECK_BOXES',
}

export interface IFilterKpiModelConfig {
  type: EFilterKpiViewTypes; // selected view component in filter
  panelTitle: string; // title for expand panel
  inputPlaceHolder?: string; // search input placeholder if needed
  optionsList?: IFilterKpiModelConfigOptionList[]; // use for RADIO_GROUP_TEMPLATE
  multiple?: boolean; // is multiselect dropdown, use for ASSET_TEMPLATE
  searchValue?: string; // value that we search;
  allSelected?: boolean;
  radioOptionsList?: string[]; // options for radio button
  optionsListSelected?: number; // selected radio button index
  panelClass?: string; // class for panel
  allAssetsSelected?: boolean; // use ASSET_TEMPLATE
  optionAssetsList?: IFilterKpiModelConfigOptionList[]; // use for ASSET_TEMPLATE
  allAssetsSelectedTitle?: string; // tittle for all selected Parks, use for ASSET_TEMPLATE
  assetsSelectedList?: IFilterKpiModelConfigOptionList[]; // use for ASSET_TEMPLATE
  selectedList?: IFilterKpiModelConfigOptionList[]; // use for CHECK_BOXES_WITH_SEARCH
  optionList?: IFilterKpiModelConfigOptionList[]; // use for  CHECK_BOXES_WITH_SEARCH
  filteredList?: IFilterKpiModelConfigOptionList[]; // use for CHECK_BOXES_WITH_SEARCH
  allSelectedTitle?: string; // tittle for all selected, use for CHECK_BOXES_WITH_SEARCH
  order?: number; // order for filter
}

export interface IFilterKpiModelConfigOptionList {
  name: string;
  id?: string;
  checked?: boolean;
  class?: string;
  parks?: {id: string, name: string}[];
  titleTranslationKey?: string;
  translatableName?: string;
}
